/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Absences_TeamsInputs */

const en_tables_absences_teams = /** @type {(inputs: Tables_Absences_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

const de_tables_absences_teams = /** @type {(inputs: Tables_Absences_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teams`)
};

/**
* | output |
* | --- |
* | "Teams" |
*
* @param {Tables_Absences_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_absences_teams = /** @type {((inputs?: Tables_Absences_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Absences_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_absences_teams(inputs)
	return de_tables_absences_teams(inputs)
});